import { component } from 'picoapp';
import Popup from '~/js/utils/popup';

const copy = require('clipboard-copy');

export default component(async (node, ctx) => {
  const SharePopup = new Popup(node);
  const triggers = [...document.querySelectorAll('[data-trigger-wishlist-share-popup]')];
  const urlSpan = document.querySelector('[data-copy-link]');
  const copyBtn = document.querySelector('[data-copy-button]');
  const socialShares = [...document.querySelectorAll('[data-social-share]')];

  if (triggers.length) {
    triggers.forEach((btn) => {
      btn.addEventListener('click', () => {
        SharePopup.open();

        if (urlSpan) {
          // set by js to avoid safari bug
          urlSpan.classList.add('line-clamp-1');
        }
      });
    });
  }

  const copied = () => {
    const { copyText, copiedText } = copyBtn.dataset;
    copyBtn.innerHTML = copiedText;

    setTimeout(() => {
      copyBtn.innerHTML = copyText;
    }, 2500);
  };

  ctx.on('wishlist:fetched', ({ wishlist }) => {
    const shareParams = {
      wkShareService: 'link',
      wkShare: wishlist.permaId,
    };

    const sharedLink = window.WishlistKing.toolkit.getShareLink(shareParams);

    if (urlSpan) {
      urlSpan.innerHTML = sharedLink;

      if (copyBtn) {
        copyBtn.addEventListener('click', () => {
          copy(urlSpan.innerText).then(() => copied());
        });
      }
    }

    if (socialShares.length) {
      socialShares.forEach((socialShare) => {
        const tempHref = socialShare.href;
        socialShare.href = `${tempHref}${sharedLink}`;

        socialShare.addEventListener('click', (e) => {
          e.preventDefault();
          window.open(
            socialShare.href,
            'Wishlist',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=500,height=500',
          );
        });
      });
    }
  });
});
